/**
 * @generated SignedSource<<5c9888583ce943a1d45661a5601738b9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type CalendarSource = "google" | "internal" | "office365";
export type useCalendarsRefetchSocketQuery$variables = {};
export type useCalendarsRefetchSocketQuery$data = {
  readonly viewer: {
    readonly calendars: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly color: string | null;
          readonly hadErrorOnSync: boolean | null;
          readonly id: string;
          readonly lastSyncDatetime: string | null;
          readonly name: string | null;
          readonly source: CalendarSource;
          readonly sourcePrimary: boolean;
          readonly syncEnabled: boolean;
        };
      }>;
    };
  };
};
export type useCalendarsRefetchSocketQuery = {
  response: useCalendarsRefetchSocketQuery$data;
  variables: useCalendarsRefetchSocketQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "CalendarConnection",
  "kind": "LinkedField",
  "name": "calendars",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CalendarEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Calendar",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "source",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "sourcePrimary",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "syncEnabled",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "color",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lastSyncDatetime",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hadErrorOnSync",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useCalendarsRefetchSocketQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useCalendarsRefetchSocketQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "024882cd91a68c82a21a54c743516ca5",
    "id": null,
    "metadata": {},
    "name": "useCalendarsRefetchSocketQuery",
    "operationKind": "query",
    "text": "query useCalendarsRefetchSocketQuery {\n  viewer {\n    calendars {\n      edges {\n        node {\n          id\n          source\n          sourcePrimary\n          syncEnabled\n          name\n          color\n          lastSyncDatetime\n          hadErrorOnSync\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "79fd44552f9f8ae303561bc8f1772fe8";

export default node;
